import { createSlice } from '@reduxjs/toolkit'

export const CampaignCountDisplayOrder = createSlice({
  name: 'campaign_count_display_order',
  initialState: {
    value: [0,1,2,3,4]
  },
  reducers: {
    updateCampaignOrder: (state, action) => {
      state.value = action.payload
    },
  },
})

export const { updateCampaignOrder } = CampaignCountDisplayOrder.actions

export default CampaignCountDisplayOrder.reducer